import ProductPrices from './ProductPrices';

export default ProductPrices;
